import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CLIENT_UA_HEADER, getClientUserAgent } from '../../utils/client-user-agent.util';
import { getEntrySource, getEntryUtm, withEntrySource } from '../../utils/entry-source.util';

/**
 * Agrega `X-Client-UA` (lo que dice el navegador de sí mismo) a las llamadas a la API
 * que ya pasan por la consulta previa de CORS: las que no son GET/HEAD y las que van con
 * sesión. Así login, registro y renovación de sesión lo llevan siempre, y una consulta
 * pública sin sesión (cartelera, checkout) no suma una consulta previa nueva.
 *
 * Va DESPUÉS de `tokenInterceptor` en la cadena, para ver el `Authorization` ya puesto.
 * Requiere que el router y core lo acepten en `allowedHeaders`: desplegar el backend
 * antes que este front.
 */
export const clientUaInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBase)) return next(req);
  if (req.headers.has(CLIENT_UA_HEADER)) return next(req);

  const alreadyPreflighted = (req.method !== 'GET' && req.method !== 'HEAD') || req.headers.has('Authorization');
  if (!alreadyPreflighted) return next(req);

  // El origen anotado al cargar la página viaja con el User-Agent: así cada sesión
  // (login o renovación) queda con de dónde llegó la persona, y cada compra con sus UTM.
  const ua = withEntrySource(getClientUserAgent(), getEntrySource(), getEntryUtm());
  if (!ua) return next(req);
  return next(req.clone({ setHeaders: { [CLIENT_UA_HEADER]: ua } }));
};
